import React from 'react'

export const TrashAudioIcon = () => (
  <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="44" height="44" rx="22" fill="#F5F8FF" />
    <path d="M14 17.5H30M20 21.5V27.5M24 21.5V27.5M15 17.5L16 29.5C16 30.0304 16.2107 30.5391 16.5858 30.9142C16.9609 31.2893 17.4696 31.5 18 31.5H26C26.5304 31.5 27.0391 31.2893 27.4142 30.9142C27.7893 30.5391 28 30.0304 28 29.5L29 17.5M19 17.5V14.5C19 14.2348 19.1054 13.9804 19.2929 13.7929C19.4804 13.6054 19.7348 13.5 20 13.5H24C24.2652 13.5 24.5196 13.6054 24.7071 13.7929C24.8946 13.9804 25 14.2348 25 14.5V17.5" stroke="#E32020" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
